module.exports = "../../../../platform/assets/pageMainIcon/ig-business-processing-1.svg";